import React from 'react';

const TabPanel = (props) => {
    const {children, value, index, ...other} = props;

    return (
        <div
            className='col-md-12'
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && children}
        </div>
    );
};

export default TabPanel;